import { Alert, Button, Modal, TextInput } from "@mantine/core";
import { QRCodeSVG } from "qrcode.react";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";
import { AlertPresets } from "../../../mantine/mantinePresets";

interface AuthAppConfirmModalProps {
  isOpen: boolean;
  appUrl: string;
  otp: string;
  error: string | Array<string> | null;
  onToggle: () => void;
  onOtpChange: (value: string) => void;
  onAuthMethodConfirm: () => void;
}

function AuthAppConfirmModal({
  isOpen,
  appUrl,
  otp,
  error,
  onToggle,
  onOtpChange,
  onAuthMethodConfirm
}: AuthAppConfirmModalProps) {
  return (
    <Modal opened={isOpen} title="Aktivierung bestätigen" onClose={onToggle}>
      <div>
        <p>
          1. Sie haben die Authentifizierungs-App als Ihre bevorzugte Methode
          für die 2-Faktor-Authentifizierung gewählt. Bitte scannen Sie den
          unten angezeigten QR-Code mit Ihrer Authentifizierungs-App.
        </p>
        <QRCodeSVG value={appUrl} />
      </div>
      <div>
        <p>
          2. Abschließend geben Sie bitte zur Bestätigung den von Ihrer App
          generierten Code im folgenden Feld ein.
        </p>
        <TextInput
          label="Code"
          placeholder="XXXXXX"
          required
          value={otp}
          onChange={(e) => onOtpChange(e.target.value)}
        />

        {error && (
          <Alert color={AlertPresets.error.color} mt="sm">
            {error}
          </Alert>
        )}
      </div>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Schließen
        </Button>
        <Button color="secondary" onClick={onAuthMethodConfirm}>
          Speichern
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { AuthAppConfirmModal, AuthAppConfirmModalProps };
